"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var FoldButton_1 = tslib_1.__importDefault(require("../../Buttons/FoldButton"));

var styles = tslib_1.__importStar(require("./CollapsibleContainer.style"));

function CollapsibleContainer(_ref) {
  var _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 144 : _ref$limit,
      moreButtonElement = _ref.moreButtonElement,
      foldButtonElement = _ref.foldButtonElement,
      _ref$hasFoldButton = _ref.hasFoldButton,
      hasFoldButton = _ref$hasFoldButton === void 0 ? false : _ref$hasFoldButton,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      onFoldClick = _ref.onFoldClick,
      onMoreClick = _ref.onMoreClick,
      children = _ref.children;
  var ref = react_1.useRef(null);

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      showMore = _react_1$useState2[0],
      setShowMore = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      showMoreButton = _react_1$useState4[0],
      setMoreButton = _react_1$useState4[1];

  var _react_1$useState5 = react_1.useState(false),
      _react_1$useState6 = _slicedToArray(_react_1$useState5, 2),
      showFoldButton = _react_1$useState6[0],
      setFoldButton = _react_1$useState6[1];

  var handleClickMore = function handleClickMore() {
    setShowMore(true);
    onMoreClick && onMoreClick();

    if (hasFoldButton) {
      setMoreButton(false);
      setFoldButton(true);
    }
  };

  var handleClickFold = function handleClickFold() {
    setShowMore(false);
    onFoldClick && onFoldClick();

    if (hasFoldButton) {
      setFoldButton(false);
      setMoreButton(true);
    }
  };

  var renderMoreButton = function renderMoreButton() {
    if (moreButtonElement) {
      return react_1.cloneElement(moreButtonElement, {
        onClick: handleClickMore
      });
    }

    return jsx_runtime_1.jsx(FoldButton_1.default, {
      css: styles.btn,
      onClick: handleClickMore,
      isFold: true
    }, void 0);
  };

  var renderFoldButton = function renderFoldButton() {
    if (foldButtonElement) {
      return react_1.cloneElement(foldButtonElement, {
        onClick: handleClickFold
      });
    }

    return jsx_runtime_1.jsx(FoldButton_1.default, {
      css: styles.btn,
      text: "\uC811\uAE30",
      onClick: handleClickFold,
      isFold: false
    }, void 0);
  };

  react_1.useEffect(function () {
    if (ref && ref.current) {
      var _ref$current$getBound = ref.current.getBoundingClientRect(),
          height = _ref$current$getBound.height;

      if (height > limit) {
        setMoreButton(true);
      }
    }
  }, [limit]);
  return jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [jsx_runtime_1.jsx("div", Object.assign({
      ref: ref,
      className: className,
      css: [styles.content, showMoreButton && !showMore && styles.contentHidden(limit)]
    }, {
      children: children
    }), void 0), showMoreButton && !showMore && jsx_runtime_1.jsx("div", Object.assign({
      className: "mrt-callapsed-contents-buttons",
      css: [styles.buttonContainer, styles.gradientBackground]
    }, {
      children: renderMoreButton()
    }), void 0), showFoldButton && showMore && hasFoldButton && jsx_runtime_1.jsx("div", Object.assign({
      className: "mrt-callapsed-contents-buttons",
      css: styles.buttonContainer
    }, {
      children: renderFoldButton()
    }), void 0)]
  }, void 0);
}

exports.default = CollapsibleContainer;